// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyWord_container__R0Jnh","input":"KeyWord_input__2wlF4","btn":"KeyWord_btn__12wA2"};